import { render } from "./UserApiKeysView.vue?vue&type=template&id=ee831ea8&scoped=true&ts=true"
import script from "./UserApiKeysView.vue?vue&type=script&lang=ts"
export * from "./UserApiKeysView.vue?vue&type=script&lang=ts"

import "./UserApiKeysView.vue?vue&type=style&index=0&id=ee831ea8&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee831ea8"]])

export default __exports__